import React, { forwardRef, useMemo } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import HaloSecurityMappingForm from "./HaloSecurityMappingForm";

const HaloSecurityCredentialsForm = forwardRef((props, ref) => {
  const fields = useMemo(
    () => [
      {
        name: "apiEndpoint",
        label: "API Endpoint",
        rules: [urlRegexValidator],
        required: true,
      },
      {
        name: "token",
        label: "Token",
        required: true,
        type: FieldTypes.PASSWORD,
      },
    ],
    []
  );
  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={HaloSecurityMappingForm}
    />
  );
});

export default HaloSecurityCredentialsForm;
